import React, { useEffect } from 'react';
import { UserProfileEdit } from './UserProfileEdit';
import { useAuth } from '../../contexts/AuthContext';
import { usePageConfig } from '../../contexts/PageConfigContext';

export const ProfilePage: React.FC = () => {
  const { user } = useAuth();
  const { setPageConfig } = usePageConfig();

  useEffect(() => {
    setPageConfig({
      title: 'Editar Perfil',
      description: 'Gestiona tu información personal y contraseña',
      actions: [],
    });
  }, [setPageConfig]);

  if (!user) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Por favor, inicia sesión para ver tu perfil</p>
      </div>
    );
  }

  return (
    <UserProfileEdit 
      userId={user.id}
      onSuccess={() => {
        console.log('Perfil actualizado exitosamente');
      }}
    />
  );
};
